import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { StatusIconTone } from '../cs-status-icon/cs-status-icon';

export enum ExerciseStatusBadgeType {
  Number = 'number',
  Complete = 'complete',
  InProgress = 'in-progress'
}

@Component({
  selector: 'cs-exercise-status-badge',
  templateUrl: 'cs-exercise-status-badge.html',
  host: { 'class': 'exercise-status-badge' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsExerciseStatusBadgeComponent {
  @Input() type: ExerciseStatusBadgeType = ExerciseStatusBadgeType.Number;
  @Input() number: string; // e.g., "1a", "2", "3b"
  /**
   * #4142 compact feedback: draw a finished exercise's badge as a filled circle with a check in it
   * (the approved mock-ups) instead of an outlined check, and an in-progress one as a filled circle
   * with a clock in it. The numbered badge is unchanged
   */
  @Input() filled = false;

  @HostBinding('class.filled')
  get isFilled() {
    return this.filled;
  }

  @HostBinding('class.type-number')
  get isTypeNumber() {
    return this.type === ExerciseStatusBadgeType.Number;
  }

  @HostBinding('class.type-complete')
  get isTypeComplete() {
    return this.type === ExerciseStatusBadgeType.Complete;
  }

  @HostBinding('class.type-in-progress')
  get isTypeInProgress() {
    return this.type === ExerciseStatusBadgeType.InProgress;
  }

  // the filled badge's colours: blue when finished, yellow while in progress
  getStatusIconTone(): StatusIconTone {
    return this.type === ExerciseStatusBadgeType.InProgress ? StatusIconTone.InProgress : StatusIconTone.Done;
  }

  getIconName(): string | undefined {
    switch (this.type) {
      case ExerciseStatusBadgeType.Complete:
        return 'checkmark-circle';
      case ExerciseStatusBadgeType.InProgress:
        return 'time';
      default:
        return undefined;
    }
  }
}
